<template>
  <div class="form-elements">
    <div class="row">
      <div class="flex md12">

        <sp-360-panel :title='usuario.nome'>
          <div>
            <div class="row">
              <div class="flex md12">
                    <div><span class="profile">{{usuario.unidade}}</span><span class="pull-right rf"> {{usuario.rf}}</span><br></div>
                    <span class="profile">{{usuario.email}}</span><br>
                    <span class="profile">{{$t(usuario.perfil)}}</span><br>
              </div>
            </div>
          </div>
        </sp-360-panel>
      </div>
    </div>
  </div>
</template>

<script>

import Multiselect from 'vue-multiselect'
import Sp360Panel from '@/components/ui/sp360-panel/sp360-panel'

export default {
  components: { Multiselect, Sp360Panel },
  name: 'perfil-usuario',
  computed: {

  },
  data () {
    return {
      usuario: {
        rf: 'S112233-4',
        email: 'rivelino@gmail.com',
        nome: 'Roberto Rivelino',
        unidade: 'Selecao1970',
        perfil: ['SECT', 'MGMT', 'ADMIN'],
        localUser: true,
      },
    }
  },
  methods: {
    valida (usuario) {

    },
    persiste (usuario) {

    },
    atualiza (usuario) {

    },
  },
  created () {
    // this.options.perfis = ['ADMIN', 'PREFEITO', 'MANAGER', 'SECRETARIO'];
    this.options.perfis = [{ id: 1, desc: 'ADMIN' }, { id: 2, desc: 'PREFEITO' }, { id: 3, desc: 'MANAGER' }, { id: 4, desc: 'SECRETARIO' }]
  },
}
</script>

<style lang="scss">
  @import "../../../node_modules/vue-multiselect/dist/vue-multiselect.min.css";
  .profile{
    padding-left: 2%;
    padding-bottom: 2%;
  }
   .rf{
      font-weight: bold;
    }
</style>
